//@flow
import actionType from './actionType';
import sendOTP from './sendOTP';
import verifyOTP from './verifyOTP';
import { sendOTPSuccessAction } from './sendOTPSuccessAction';
import { sendOTPFailureAction } from './sendOTPFailureAction';
import { verifyOTPSuccessAction } from './verifyOTPSuccessAction';
import { verifyOTPFailureAction } from './verifyOTPFailureAction';
import { verifyOTPSuccessActionBic } from './verifyOTPSuccessActionBic';
import getLenderList from './getLenderList';
import { lenderListSuccessAction } from './lenderListSuccessAction';
import { lenderListFailureAction } from './lenderListFailureAction';
import { ntbActionType } from '../../actionTypes';

export default (action: string, actionPayload?: Object) => (
  dispatch: Function,
) => {
  switch (action) {
    case actionType.sendOTP: {
      const {
        mobile,
        merchantId,
        channel,
        utmSource,
        utmContent,
        utmMedium,
        utmTerm,
        campaignId,
      } = actionPayload || {};
      return dispatch(
        sendOTP(
          {
            mobile,
            merchantId,
            channel,
            utmContent,
            utmMedium,
            utmSource,
            utmTerm,
            campaignId,
          },
          sendOTPSuccessAction,
          sendOTPFailureAction,
        ),
      );
    }

    case actionType.verifyOTP: {
      const {
        mobile,
        otp,
        channel,
        utmSource,
        utmMedium,
        campaignId,
        utmContent,
        utmTerm,
        samePage,
        variant,
        variation,
        urls,
        merchantId,
      } = actionPayload || {};
      return dispatch(
        verifyOTP(
          {
            mobile,
            otp,
            channel,
            utmSource,
            utmMedium,
            campaignId,
            utmContent,
            utmTerm,
            samePage,
            variant,
            variation,
            urls,
            merchantId,
          },
          verifyOTPSuccessAction,
          verifyOTPFailureAction,
        ),
      );
    }

    case actionType.verifyOTPBic: {
      const { mobile, otp, channel, samePage } = actionPayload || {};
      return dispatch(
        verifyOTP(
          {
            mobile,
            otp,
            channel,
            samePage,
          },
          verifyOTPSuccessActionBic,
          verifyOTPFailureAction,
        ),
      );
    }

    case actionType.getLenderList: {
      const { mobile, merchantId = null } = actionPayload || {};
      return dispatch(
        getLenderList(
          { mobile, merchantId },
          lenderListSuccessAction,
          lenderListFailureAction,
        ),
      );
    }

    case actionType.closeOtpOverLayScreen: {
      return dispatch({
        type: ntbActionType.CLOSE_OTP_OVERLAY_SCREEN,
        payload: '',
      });
    }

    case actionType.openOverlayScreen: {
      return dispatch({
        type: ntbActionType.OPEN_OVERLAY_SCREEN,
        payload: '',
      });
    }

    case actionType.closeOverlayScreen: {
      return dispatch({
        type: ntbActionType.CLOSE_OVERLAY_SCREEN,
        payload: '',
      });
    }

    case actionType.initLenderListScreen: {
      return dispatch({
        type: ntbActionType.INIT_LENDER_LIST_SCREEN,
        payload: actionPayload,
      });
    }

    case actionType.resetUserStatus: {
      return dispatch({
        type: ntbActionType.USER_STATUS,
        payload: { userStatus: 'nonLoggedIn' },
      });
    }

    case actionType.closeEligibilityModal: {
      return dispatch({
        type: ntbActionType.CLOSE_ELIGIBILITY_MODAL,
        payload: '',
      });
    }

    case actionType.closeEligibilityCheckModal: {
      return dispatch({
        type: ntbActionType.CLOSE_ELIGIBILITY_CHECK_MODAL,
        payload: '',
      });
    }

    default:
      return null;
  }
};



// WEBPACK FOOTER //
// ./actions/ntbAction/index.js